export default function ProductTagList() {
    return (
        <div className="styles_containerList__JeHRb">
            <a
                className="styles_mobile_rootBase__8z7PQ styles_item__WLG0R"
                href="[object Object]"
            >
                <div className="styles_wrapperContent__MBs8N">
                    <span>🔥 Hàng tuyển, Giá tốt</span>
                </div>
            </a>

            <a
                className="styles_mobile_rootBase__8z7PQ styles_item__WLG0R"
                href="[object Object]"
            >
                <div className="styles_wrapperContent__MBs8N">
                    <span>👍 Sản phẩm bán chạy</span>
                </div>
            </a>

            <a
                className="styles_mobile_rootBase__8z7PQ styles_item__WLG0R"
                href="[object Object]"
            >
                <div className="styles_wrapperContent__MBs8N">
                    <span>🧧 Mua nhiều, Giảm nhiều</span>
                </div>
            </a>

            <a
                className="styles_mobile_rootBase__8z7PQ styles_item__WLG0R"
                href="[object Object]"
            >
                <div className="styles_wrapperContent__MBs8N">
                    <span>🎁 Mua là tặng</span>
                </div>
            </a>

            <a
                className="styles_mobile_rootBase__8z7PQ styles_item__WLG0R"
                href="[object Object]"
            >
                <div className="styles_wrapperContent__MBs8N">
                    <span>Hàng Lạnh</span>
                </div>
            </a>

            <a
                className="styles_mobile_rootBase__8z7PQ styles_item__WLG0R"
                href="[object Object]"
            >
                <div className="styles_wrapperContent__MBs8N">
                    <span>Phân Phối Bệnh Viện</span>
                </div>
            </a>

            <a
                className="styles_mobile_rootBase__8z7PQ styles_item__WLG0R"
                href="[object Object]"
            >
                <div className="styles_wrapperContent__MBs8N">
                    <span>Có hàng lại</span>
                </div>
            </a>

            <a
                className="styles_mobile_rootBase__8z7PQ styles_item__WLG0R"
                href="[object Object]"
            >
                <div className="styles_wrapperContent__MBs8N">
                    <span>Cận date</span>
                </div>
            </a>
        </div>
    )
}
